export const validateMixins = {
  methods: {
    resetForm() {
      this.$nextTick(() => {
        this.errors.clear()
        this.$nextTick(() => {
          this.$validator.reset()
        })
      })
    }
  }
}
